import apiClient from '../authentication/utils/core/axios';

// Credential Quiz API service -- standalone Knowledge Assessment system,
// 2026-07-19. Deliberately not part of the credibility API module; this
// data never feeds compute_user_parts()/global_score (see
// backend_stocker/app/models/credential_quiz_model.py's own docstring).
const CredentialQuizAPI = {
  // -- User-facing --
  fetchTopics: async () => {
    const res = await apiClient.get('/credential-quiz/topics');
    return res.data;
  },
  fetchQuiz: async (topicId, level) => {
    const res = await apiClient.get(`/credential-quiz/topics/${topicId}/${level}`);
    return res.data;
  },
  submitQuiz: async (topicId, level, answers) => {
    const res = await apiClient.post(`/credential-quiz/topics/${topicId}/${level}/submit`, { answers });
    return res.data;
  },
  fetchMySummary: async () => {
    const res = await apiClient.get('/credential-quiz/my-summary');
    return res.data;
  },

  // -- Admin --
  adminFetchTopics: async () => {
    const res = await apiClient.get('/admin/credential-quiz/topics');
    return res.data;
  },
  adminCreateTopic: async (payload) => {
    const res = await apiClient.post('/admin/credential-quiz/topics', payload);
    return res.data;
  },
  adminUpdateTopic: async (topicId, payload) => {
    const res = await apiClient.put(`/admin/credential-quiz/topics/${topicId}`, payload);
    return res.data;
  },
  adminDeleteTopic: async (topicId) => {
    await apiClient.delete(`/admin/credential-quiz/topics/${topicId}`);
    return topicId;
  },
  adminFetchQuestions: async (topicId) => {
    const res = await apiClient.get(`/admin/credential-quiz/topics/${topicId}/questions`);
    return res.data;
  },
  adminCreateQuestion: async (topicId, payload) => {
    const res = await apiClient.post(`/admin/credential-quiz/topics/${topicId}/questions`, payload);
    return res.data;
  },
  adminUpdateQuestion: async (questionId, payload) => {
    const res = await apiClient.put(`/admin/credential-quiz/questions/${questionId}`, payload);
    return res.data;
  },
  adminDeleteQuestion: async (questionId) => {
    await apiClient.delete(`/admin/credential-quiz/questions/${questionId}`);
    return questionId;
  },
};

export default CredentialQuizAPI;
